export const termsConditions = {
  title: 'TERMENI ȘI CONDIȚII',
  updatedAt: '2026-09-27',
  text: `Bine ați venit pe website-ul Oranjina Biscotina.

Prin accesarea și utilizarea acestui website, confirmați că ați citit și că sunteți de acord cu prezentele Termeni și Condiții. Dacă nu sunteți de acord cu acestea, vă rugăm să nu utilizați website-ul.

Acești Termeni și Condiții se aplică utilizării website-ului Oranjina Biscotina și funcției de solicitare a rezervărilor disponibile pe acesta.

## 1. Date despre Oranjina Biscotina

Denumire juridică: EUROINVEST RESOLVE ENTERPRISE S.R.L
CUI: 45381053
Nr. Registrului Comerțului: J2021007921233
Sediu social: Jud. Ilfov, Sat Rosu, Comuna Chiajna, Strada WEINER PALADA , Nr. 1, parter, camera 1, Bl. C1, Ap.20
Adresă locație: Strada Constantin Brâncoveanu 8 A, Mogoșoaia, România
Telefon: 0784 173 284
E-mail: andreeanastasiuc@gmail.com

În cuprinsul prezentelor Termeni și Condiții, denumirile „Oranjina Biscotina”, „noi”, „nostru” sau „locația” se referă la operatorul juridic al locației, identificat mai sus.

## 2. Despre website

Website-ul are rol în principal informativ și are ca scop prezentarea locației Oranjina Biscotina, a serviciilor și a informațiilor relevante pentru clienți.

Website-ul poate permite utilizatorilor să transmită solicitări de rezervare.

Website-ul nu oferă în prezent:

- posibilitatea de a plasa comenzi online;
- cumpărarea de produse prin intermediul website-ului;
- plata online;
- servicii de livrare la domiciliu;
- crearea unui cont de utilizator, cu excepția cazului în care această funcționalitate va fi introdusă ulterior.

## 3. Utilizarea website-ului

Utilizatorii se obligă să utilizeze website-ul în mod legal și să nu îl folosească pentru:

- activități ilegale;
- transmiterea de informații false sau înșelătoare;
- încercarea de a obține acces neautorizat la sistemele website-ului;
- transmiterea de viruși, cod malițios sau alte elemente care pot afecta funcționarea website-ului;
- efectuarea de rezervări fictive, abuzive sau repetate fără intenția de a le onora.

Oranjina Biscotina își rezervă dreptul de a lua măsurile necesare în cazul utilizării abuzive a website-ului.

## 4. Rezervări

Website-ul poate permite transmiterea unei solicitări de rezervare.

Pentru transmiterea unei rezervări, utilizatorului i se poate solicita furnizarea numărului de telefon și, în funcție de configurația formularului, a altor informații necesare gestionării rezervării.

Transmiterea formularului reprezintă o solicitare de rezervare și nu constituie în mod automat confirmarea rezervării.

Rezervarea este considerată confirmată numai după confirmarea acesteia de către Oranjina Biscotina, prin modalitatea de contact disponibilă.

În cazul în care rezervarea nu poate fi onorată la data sau ora solicitată, reprezentantul Oranjina Biscotina poate contacta persoana care a transmis solicitarea pentru a propune o alternativă sau pentru a informa cu privire la indisponibilitate.

## 5. Datele furnizate pentru rezervare

Utilizatorul este responsabil pentru corectitudinea informațiilor furnizate prin formularul de rezervare.

În special, numărul de telefon furnizat trebuie să fie corect și funcțional pentru a permite contactarea utilizatorului în legătură cu rezervarea.

Datele furnizate prin formular vor fi utilizate pentru gestionarea solicitării și a rezervării, conform Politicii de Confidențialitate.

Nu introduceți în câmpurile formularului informații sensibile sau alte date care nu sunt necesare pentru efectuarea rezervării.

## 6. Anularea sau modificarea rezervării

În cazul în care nu mai puteți ajunge la o rezervare sau doriți modificarea acesteia, vă recomandăm să contactați Oranjina Biscotina cât mai curând posibil la:

0784 173 284

Condițiile specifice privind anularea, modificarea sau întârzierea la o rezervare pot fi comunicate de Oranjina Biscotina la momentul confirmării rezervării sau prin intermediul personalului locației.

## 7. Întârzierea sau neprezentarea

În cazul în care persoana care a efectuat rezervarea nu se prezintă la locație sau întârzie semnificativ, Oranjina Biscotina poate lua măsuri privind păstrarea mesei rezervate, în funcție de disponibilitate și de circumstanțele concrete.

În lipsa unei reguli comunicate în mod expres, recomandăm contactarea locației în cazul unei întârzieri.

## 8. Prețuri, produse și disponibilitate

Informațiile, imaginile, meniurile, produsele, serviciile și prețurile prezentate pe website pot fi modificate fără notificare prealabilă.

Disponibilitatea produselor și serviciilor poate varia.

Imaginile prezentate pe website au caracter informativ și pot exista diferențe între aspectul produselor prezentate în imagini și produsele servite efectiv.

Prețurile și condițiile aplicabile la locație sunt cele comunicate și afișate de Oranjina Biscotina la momentul achiziției.

## 9. Fără vânzări și plăți online

Website-ul nu permite în prezent efectuarea de comenzi sau plăți online.

Transmiterea unei solicitări de rezervare nu implică efectuarea unei plăți prin intermediul website-ului.

Orice plată pentru produsele sau serviciile consumate la locație se realizează conform modalităților de plată disponibile la Oranjina Biscotina.

## 10. Proprietate intelectuală

Conținutul website-ului, inclusiv, fără limitare:

- textele;
- fotografiile;
- elementele grafice;
- logo-ul;
- identitatea vizuală;
- designul website-ului;
- elementele software;

poate fi protejat de legislația privind drepturile de autor și proprietatea intelectuală.

Reproducerea, distribuirea, modificarea sau utilizarea comercială a conținutului website-ului fără acordul titularului drepturilor este interzisă, în măsura permisă și prevăzută de legislația aplicabilă.

## 11. Conținut furnizat de utilizatori

Dacă website-ul permite transmiterea de mesaje, recenzii, fotografii sau alte materiale de către utilizatori, aceștia sunt responsabili pentru conținutul transmis.

Utilizatorii nu trebuie să transmită conținut care:

- încalcă drepturile altor persoane;
- este ilegal;
- este defăimător, amenințător sau discriminatoriu;
- conține informații personale ale altor persoane fără drept;
- încalcă drepturile de autor sau alte drepturi de proprietate intelectuală.

## 12. Linkuri către website-uri terțe

Website-ul poate conține linkuri către website-uri sau platforme terțe, inclusiv rețele sociale.

Oranjina Biscotina nu controlează conținutul și politicile acestor website-uri și nu este responsabilă pentru modul în care acestea prelucrează datele utilizatorilor.

Utilizarea website-urilor terțe este supusă termenilor și politicilor proprii ale acestora.

## 13. Disponibilitatea website-ului

Depunem eforturi pentru ca website-ul să fie disponibil și să funcționeze corespunzător.

Cu toate acestea, nu putem garanta că website-ul va fi disponibil permanent sau fără întreruperi.

Website-ul poate fi temporar indisponibil din cauza lucrărilor de mentenanță, actualizărilor, problemelor tehnice, problemelor furnizorilor de servicii sau altor circumstanțe independente de controlul nostru.

## 14. Limitarea responsabilității

Informațiile prezentate pe website sunt furnizate în scop informativ.

Depunem eforturi rezonabile pentru ca informațiile publicate să fie corecte și actualizate, însă anumite informații, inclusiv disponibilitatea, programul, meniul sau prețurile, se pot modifica.

În măsura permisă de legislația aplicabilă, Oranjina Biscotina nu poate fi ținută responsabilă pentru prejudiciile rezultate exclusiv din utilizarea unor informații care au devenit între timp neactualizate, atunci când acestea au fost modificate ulterior publicării.

Nicio prevedere din prezentele Termeni și Condiții nu limitează drepturile consumatorilor sau răspunderea care nu poate fi exclusă ori limitată potrivit legislației aplicabile.

## 15. Protecția datelor personale

Prelucrarea datelor cu caracter personal furnizate prin intermediul website-ului, inclusiv în legătură cu rezervările, este descrisă în Politica de Confidențialitate.

Prin utilizarea website-ului, utilizatorii sunt încurajați să consulte Politica de Confidențialitate pentru a afla:

- ce date sunt colectate;
- în ce scop sunt utilizate;
- temeiul juridic al prelucrării;
- cât timp sunt păstrate;
- cui pot fi transmise;
- ce drepturi au persoanele vizate.

## 16. Cookie-uri

Website-ul poate utiliza cookie-uri sau tehnologii similare.

Utilizarea acestora este descrisă în Politica de Cookie-uri, dacă aceasta este aplicabilă configurației tehnice a website-ului.

Cookie-urile strict necesare pentru funcționarea website-ului pot fi utilizate în conformitate cu legislația aplicabilă.

Cookie-urile care necesită consimțământ vor fi utilizate numai în condițiile prevăzute de legislația aplicabilă și, după caz, după obținerea consimțământului utilizatorului.

## 17. Modificarea Termenilor și Condițiilor

Oranjina Biscotina poate modifica sau actualiza prezentele Termeni și Condiții pentru a reflecta modificări ale website-ului, serviciilor oferite sau legislației aplicabile.

Versiunea actuală va fi disponibilă pe website și va indica data ultimei actualizări.

## 18. Legislația aplicabilă

Prezentele Termeni și Condiții sunt guvernate de legislația aplicabilă în România.

Orice litigiu va fi soluționat pe cale amiabilă, atunci când acest lucru este posibil.

În cazul în care soluționarea amiabilă nu este posibilă, litigiile vor fi soluționate de instanțele competente, cu respectarea drepturilor consumatorilor și a normelor legale aplicabile privind competența instanțelor.

## 19. Contact

Pentru întrebări, solicitări sau informații referitoare la website, rezervări sau prezentele Termeni și Condiții, ne puteți contacta:

Oranjina Biscotina
Strada Constantin Brâncoveanu 8 A
Mogoșoaia, România
Telefon: 0784 173 284
E-mail: andreeanastasiuc@gmail.com
Denumire juridică: EUROINVEST RESOLVE ENTERPRISE S.R.L
CUI: 45381053
Nr. Registrul Comerțului: J2021007921233`,
};